import {
  Children,
  isValidElement,
  ReactElement,
  cloneElement,
  FC,
  PropsWithChildren
} from 'react';

import {
  Chip,
  ChipGroupProps as MantineChipGroupProps,
  ChipProps
} from '@mantine/core';

interface ChipGroupProps<T extends boolean = false | true>
  extends MantineChipGroupProps<T> {
  disabled?: boolean;
  id?: string;
  tick?: boolean;
}

const ChipGroup: FC<PropsWithChildren<ChipGroupProps>> = ({
  disabled = false,
  children,
  ...rest
}) => {
  const childrenWithProps = Children.map(
    children as ReactElement<ChipProps>[],
    (child: ReactElement<ChipProps>) => {
      if (isValidElement(child)) {
        return cloneElement(child, {
          ...child.props,
          multiple: rest.multiple || child.props.multiple,
          disabled: disabled || child.props.disabled
        });
      }
      return child;
    }
  );

  return <Chip.Group {...rest}>{childrenWithProps}</Chip.Group>;
};

export { ChipGroup };
export type { ChipGroupProps };
